import { render, staticRenderFns } from "./SelecionarTipoLaudo.vue?vue&type=template&id=55d43ee2&scoped=true&lang=pug"
import script from "./SelecionarTipoLaudo.vue?vue&type=script&lang=js"
export * from "./SelecionarTipoLaudo.vue?vue&type=script&lang=js"
import style0 from "./SelecionarTipoLaudo.vue?vue&type=style&index=0&id=55d43ee2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d43ee2",
  null
  
)

export default component.exports